import {
  REQUEST_EXTERNALISED_STRINGS,
  RECEIVE_EXTERNALISED_STRINGS,
  FINISH_EXTERNALISED_STRINGS_FETCHING,
  RECEIVE_ERROR,
} from './actions';

export const initialState = {
  error: null,
  isFetching: false,
  received: false,
};

const ACTIONS = {
  [REQUEST_EXTERNALISED_STRINGS]: ({ state }) => ({ ...state, isFetching: true }),
  [RECEIVE_EXTERNALISED_STRINGS]: ({ state, action }) => ({
    ...state,
    ...action,
    error: null,
    received: true,
  }),
  [FINISH_EXTERNALISED_STRINGS_FETCHING]: ({ state }) => ({ ...state, isFetching: false }),
  [RECEIVE_ERROR]: ({ action }) => ({ ...initialState, error: action.error, isFetching: false }),
};

export default function externalisedStrings(state = initialState, action) {
  return ACTIONS[action.type] ? ACTIONS[action.type]({ state, action }) : state;
}
